import type { FileInfo } from "@exagens/behavioral-insight-console-client";
import { createSlice } from "@reduxjs/toolkit";
import {
  sparxsEditorCatalogReplaced,
  sparxsEditorSaveSucceededForFiles,
} from "@/features/sparxsEditor/store/domainActions";

export type SparxsListState = {
  data: FileInfo[];
  excludedData: FileInfo[];
};

const initialState: SparxsListState = {
  data: [],
  excludedData: [],
};

const SparxsListSlice = createSlice({
  name: "sparxsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sparxsEditorCatalogReplaced, (state, action) => {
        state.data = action.payload.files;
        state.excludedData = action.payload.excludedFiles;
      })
      .addCase(sparxsEditorSaveSucceededForFiles, (state, action) => {
        for (const row of action.payload.saved) {
          const idx = state.data.findIndex((f) => f.fileName === row.fileName);
          if (idx >= 0) {
            const prev = state.data[idx];
            state.data[idx] = {
              ...prev,
              lastModified: row.serverLastModifiedMs,
            };
          }
        }
      });
  },
});

export default SparxsListSlice.reducer;
